<template>
  <div>
    <div class="titlePage">Tratamento das inscrições</div>
    <template v-if="idNotificacao == 0">
      <div class="mt-3">Solicitações de Inscrições Deferidas e Canceladas</div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsSolicitacoes"
            :orderby="sortBy"
            :actions="actionsSolicitacoes"
            :items="lstSolicitacoes"
            responsive
            :porPage="itemPorPage"
            :titlePage="titlePage"
            :titlePDF="titlePage"
          ></fccTable>
        </div>
      </div>
    </template>
    <template v-else>
      <FccListaSolicitacoes
        @zerarSolicitacao="zerarSolicitacao"
        :controlePage="controlePage"
        :baseUrlPublicacao="baseUrlPublicacao"
        :idNotificacao="idNotificacao"
      />
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import FccListaSolicitacoes from './fccListaSolicitacoes.vue'
export default {
  data() {
    return {
      titlePage: 'Publicações',
      baseUrlPublicacao: '',
      sortBy: 'nome',
      itemPorPage: '1000',
      idNotificacao: 0,
      actionsSolicitacoes: [
        {
          button: true,
          funcaoButton: 'visualizaSolicitacao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      lstSolicitacoes: [],
      fieldsSolicitacoes: [
        { key: 'numero', label: 'Nº', sortable: true },
        { key: 'tipopublicacao', label: 'Tipo de Publicação	', sortable: true },
        { key: 'solicitante', label: 'Solicitante', sortable: true },
        { key: 'datasolicitacao', label: 'Data de Solicitação' },
        { key: 'datapublicacao', label: 'Data de Publicação' },
        { key: 'tecniconapd', label: 'Técnico NAPD' },
        { key: 'importacao', label: 'Importação', sortable: true },
        { key: 'statusfinal', label: 'Status' }
      ]
    }
  },
  components: { FccListaSolicitacoes },
  methods: {
    visualizaSolicitacao(_, item) {
      this.idNotificacao = item.numero
    },
    zerarSolicitacao(number) {
      this.idNotificacao = number
    },
    listarSolicitacoes() {
      axios
        .get(
          this.baseUrlPublicacao +
            'InscricoesDeferidasCanceladas/ListarInscricoesDeferidasCanceladas/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitacoes = response.data
          if (this.lstSolicitacoes.length > 0) {
            this.lstSolicitacoes.forEach(function (data) {
              data['statusfinal'] = data['status']
              delete data['status']
            })
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.idNotificacao = 0
    this.listarSolicitacoes()
  }
}
</script>
